import { render, staticRenderFns } from "./PolicyDocumentPublishedNotification.vue?vue&type=template&id=f875b594&scoped=true&"
import script from "./PolicyDocumentPublishedNotification.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentPublishedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f875b594",
  null
  
)

export default component.exports